export default {
	section_banner: {
		title: {
			one: 'プラットフォームと ',
			two: '特徴',
		},
		paragraph: {
			one: 'ビジネス管理に最適化され、',
			two: 'JPWorldPayは、企業向けに設計された強力なツールを提供しています。',
			three: '業務を合理化します。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	seller_access: {
		label: 'ビジネスを最適化',
		title: {
			one: 'フランチャイズから',
			two: '管理',
			three: 'に',
			four: '正確な決済',
		},
		paragraph:
			'あなたのビジネスに最適化されたプラットフォームを見つけてください。JPWorldPayは、シームレスな決済ソリューション、スマートな金融ツール、そして安全な取引を提供し、お客様独自の業務ニーズをサポートするように設計されています。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	question_sec: {
		label: 'できるだけシンプルに',
		title: {
			one: '直感的',
			two: '&',
			three: '単純',
		},
		paragraph: {
			one: 'ビジネスに関しては、可能な限りシンプルに。JPWorldPayは、財務ワークフローのあらゆるステップを効率化します。',
			two: '支払いの受け取りから取引の管理まで、すべてを自動化できるので、ビジネスの運営と成長に集中できます。',
			three:
				'直感的なツールとユーザーフレンドリーなインターフェースにより、ビジネス財務の管理がこれまでになく簡単になります。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	seller_access_rt: {
		label: 'プラットフォームと機能',
		title: {
			one: 'すぐに使える',
			two: '右',
			three: '離れて',
			four: '学ばずに',
		},
		paragraph:
			'プラットフォームと機能はシンプルに設計されており、管理者が簡単に使用できます。JPWorldPayは、すっきりとしたインターフェースと直感的なナビゲーションにより、複雑さを排除し、日々の運用をシンプルかつ効率的にします。',
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
